// Что доступно какой роли — правило в одном месте; база проверяет то же самое (is_writer, apply_changes),
// здесь — интерфейс. Спека: docs/superpowers/specs/2026-09-13-people-accounts-roles-design.md
//   none   — входа нет
//   viewer — читает всё, свои настройки, вопросы и ответы; без жестов, кнопок записи и Save
//   member — плюс план: задачи, проекты, события, отпуска, лончи, ленты, порядок строк, откат в истории
//   admin  — плюс люди, команды, аккаунты и роли, общие настройки
// Применение: <WriteOnly> вокруг кнопок и ручек, useCanWrite() в меню и карточках, canWriteNow() в жестах
// (interaction.tsx) — там роль читается в обработчике, а не при рендере. Списки таблиц по ролям, canWriteTable
// и подписи — roles.ts (без React).
import type { ReactNode } from 'react';
import { useAuth } from './store';
import { isAdminRole, isWriter } from './roles';

export const useCanWrite = (): boolean => useAuth((s) => isWriter(s.profile?.role));
export const useIsAdmin = (): boolean => useAuth((s) => isAdminRole(s.profile?.role));
/** Для обработчиков событий вне рендера: начало перетаскивания, клавиши. */
export const canWriteNow = (): boolean => isWriter(useAuth.getState().profile?.role);

/** Дети только пишущему: кнопки создания, ручки порядка, действия на строке. */
export function WriteOnly({ children }: { children: ReactNode }) {
  return useCanWrite() ? <>{children}</> : null;
}
